import { faClock, faMap, faStar } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import useItemsPaginator from '../../../../hooks/useItemsPaginator';
import { openModalSuccess } from '../../../../utils/modals';
import Card from '../../Card';

const SectionCards = ({ list }) => {
  const { items: renderedItems, PaginatorComponent } = useItemsPaginator(list);

  const getAddress = ({ calle, numero, deno_loc, deno_part, deno_prov }) => {
    const location = [deno_loc, deno_part, deno_prov].filter((item) => !!item).join(', ');

    return `${calle} ${numero}, ${location}`;
  };

  const showHours = (item) => {
    return !!item.lun || !!item.mar || !!item.mier || !!item.jue || !!item.vie;
  };

  const openHours = ({ lun, mar, mier, jue, vie, ...item }) => {
    openModalSuccess({
      title: 'Horarios',
      size: 'md',
      children: (
        <section className='d-flex flex-column align-items-start gap-2'>
          <p className='h4'>
            {item.Prestad_Tipo === 'P' ? `${item.nombre_abre} ${item.ape_razon}` : item.ape_razon}
          </p>
          {!!lun && (
            <p className='h5'>
              <small className='text-secondary'>Lunes: </small>
              {lun}h.
            </p>
          )}
          {!!mar && (
            <p className='h5'>
              <small className='text-secondary'>Martes: </small>
              {mar}h.
            </p>
          )}
          {!!mier && (
            <p className='h5'>
              <small className='text-secondary'>Miercoles: </small>
              {mier}h.
            </p>
          )}
          {!!jue && (
            <p className='h5'>
              <small className='text-secondary'>Jueves: </small>
              {jue}h.
            </p>
          )}
          {!!vie && (
            <p className='h5'>
              <small className='text-secondary'>Viernes: </small>
              {vie}h.
            </p>
          )}
        </section>
      ),
    });
  };

  return (
    <>
      {list && (
        <div className='row shadow-sm rounded-3 py-3 px-md-5 my-4'>
          {renderedItems?.map((item, index) => (
            <div key={`item-card-${index}`} className='col-12 col-xl-6 py-3 px-xxl-3'>
              <Card className='h-100'>
                <Card.Header>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <p className='my-0 h5'>
                        {/* {item.id} */}
                        <strong>
                          {item.Prestad_Tipo === 'P'
                            ? `${item.nombre_abre} ${item.ape_razon}`
                            : item.ape_razon}
                        </strong>
                      </p>
                      <p className='text-black-50 my-0'>
                        <small>{item.Especialidad}</small>
                      </p>
                    </div>
                    {item.calificacion && (
                      <div className='my-0 d-flex align-content-start gap-2'>
                        <p className='text-black-50 '>{parseFloat(item.calificacion).toFixed(1)}</p>
                        <FontAwesomeIcon icon={faStar} className='mt-1' />
                      </div>
                    )}
                  </div>
                </Card.Header>
                <Card.Body>
                  <p className='text-black-50 my-0'>Telefono</p>
                  <p>
                    <strong>{item.tele}</strong>
                  </p>
                  <p className='text-black-50 my-0'>Ubicación</p>
                  <p>{getAddress(item)}</p>
                </Card.Body>
                <Card.Footer>
                  <div className='d-flex justify-content-between h-100'>
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${getAddress(item)}`}
                      target='_blank'
                      className='text-danger text-decoration-none h-100'
                      style={{ height: 100 }}
                    >
                      <div className='d-flex gap-2'>
                        <FontAwesomeIcon icon={faMap} className='my-auto' />
                        <p className='my-auto'>
                          <strong>Ver Ubicación</strong>
                        </p>
                      </div>
                    </a>
                    {showHours(item) && (
                      <button
                        className='d-flex gap-2 text-danger'
                        style={{ border: 'none', background: 'white' }}
                        onClick={() => openHours(item)}
                      >
                        <FontAwesomeIcon icon={faClock} className='my-auto' />
                        <p className='my-auto'>
                          <strong>Ver Horarios</strong>
                        </p>
                      </button>
                    )}
                  </div>
                </Card.Footer>
              </Card>
            </div>
          ))}
          {PaginatorComponent}
          {list && isEmpty(renderedItems) && (
            <div className='col-12 d-flex justify-content-center my-4'>
              <p>No se encontraron resultados.</p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SectionCards;
